// Title: Imports
// Description: Import necessary dependencies for React, internationalization, and API calls
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { getAutocompleteSuggestions, verifyAddress } from "../api/verifyAddress";

// Title: Country Options
// Description: Define an array of country options for the country select dropdown
const countryOptions = [
  { label: "Afghanistan", value: "AFG" },
  { label: "Albania", value: "ALB" },
  { label: "Algeria", value: "DZA" },
  { label: "Andorra", value: "AND" },
  { label: "Angola", value: "AGO" },
  { label: "Antigua and Barbuda", value: "ATG" },
  { label: "Argentina", value: "ARG" },
  { label: "Armenia", value: "ARM" },
  { label: "Australia", value: "AUS" },
  { label: "Austria", value: "AUT" },
  { label: "Azerbaijan", value: "AZE" },
  { label: "Bahamas", value: "BHS" },
  { label: "Bahrain", value: "BHR" },
  { label: "Bangladesh", value: "BGD" },
  { label: "Barbados", value: "BRB" },
  { label: "Belarus", value: "BLR" },
  { label: "Belgium", value: "BEL" },
  { label: "Belize", value: "BLZ" },
  { label: "Benin", value: "BEN" },
  { label: "Bhutan", value: "BTN" },
  { label: "Bolivia", value: "BOL" },
  { label: "Bosnia and Herzegovina", value: "BIH" },
  { label: "Botswana", value: "BWA" },
  { label: "Brazil", value: "BRA" },
  { label: "Brunei", value: "BRN" },
  { label: "Bulgaria", value: "BGR" },
  { label: "Burkina Faso", value: "BFA" },
  { label: "Burundi", value: "BDI" },
  { label: "Cabo Verde", value: "CPV" },
  { label: "Cambodia", value: "KHM" },
  { label: "Cameroon", value: "CMR" },
  { label: "Canada", value: "CAN" },
  { label: "Central African Republic", value: "CAF" },
  { label: "Chad", value: "TCD" },
  { label: "Chile", value: "CHL" },
  { label: "China", value: "CHN" },
  { label: "Colombia", value: "COL" },
  { label: "Comoros", value: "COM" },
  { label: "Congo, Democratic Republic of the", value: "COD" },
  { label: "Congo, Republic of the", value: "COG" },
  { label: "Costa Rica", value: "CRI" },
  { label: "Croatia", value: "HRV" },
  { label: "Cuba", value: "CUB" },
  { label: "Cyprus", value: "CYP" },
  { label: "Czech Republic", value: "CZE" },
  { label: "Denmark", value: "DNK" },
  { label: "Djibouti", value: "DJI" },
  { label: "Dominica", value: "DMA" },
  { label: "Dominican Republic", value: "DOM" },
  { label: "Ecuador", value: "ECU" },
  { label: "Egypt", value: "EGY" },
  { label: "El Salvador", value: "SLV" },
  { label: "Equatorial Guinea", value: "GNQ" },
  { label: "Eritrea", value: "ERI" },
  { label: "Estonia", value: "EST" },
  { label: "Eswatini", value: "SWZ" },
  { label: "Ethiopia", value: "ETH" },
  { label: "Fiji", value: "FJI" },
  { label: "Finland", value: "FIN" },
  { label: "France", value: "FRA" },
  { label: "Gabon", value: "GAB" },
  { label: "Gambia", value: "GMB" },
  { label: "Georgia", value: "GEO" },
  { label: "Germany", value: "DEU" },
  { label: "Ghana", value: "GHA" },
  { label: "Greece", value: "GRC" },
  { label: "Grenada", value: "GRD" },
  { label: "Guatemala", value: "GTM" },
  { label: "Guinea", value: "GIN" },
  { label: "Guinea-Bissau", value: "GNB" },
  { label: "Guyana", value: "GUY" },
  { label: "Haiti", value: "HTI" },
  { label: "Hondorus", value: "HND" },
  { label: "Hungary", value: "HUN" },
  { label: "Iceland", value: "ISL" },
  { label: "India", value: "IND" },
  { label: "Indonesia", value: "IDN" },
  { label: "Iran", value: "IRN" },
  { label: "Iraq", value: "IRQ" },
  { label: "Ireland", value: "IRL" },
  { label: "Israel", value: "ISR" },
  { label: "Italy", value: "ITA" },
  { label: "Jamaica", value: "JAM" },
  { label: "Japan", value: "JPN" },
  { label: "Jordan", value: "JOR" },
  { label: "Kazakhstan", value: "KAZ" },
  { label: "Kenya", value: "KEN" },
  { label: "Kiribati", value: "KIR" },
  { label: "Korea, North", value: "PRK" },
  { label: "Korea, South", value: "KOR" },
  { label: "Kuwait", value: "KWT" },
  { label: "Kyrgyzstan", value: "KGZ" },
  { label: "Laos", value: "LAO" },
  { label: "Latvia", value: "LVA" },
  { label: "Lebanon", value: "LBN" },
  { label: "Lesotho", value: "LSO" },
  { label: "Liberia", value: "LBR" },
  { label: "Libya", value: "LBY" },
  { label: "Liechtenstein", value: "LIE" },
  { label: "Lithuania", value: "LTU" },
  { label: "Luxembourg", value: "LUX" },
  { label: "Madagascar", value: "MDG" },
  { label: "Malawi", value: "MWI" },
  { label: "Malaysia", value: "MYS" },
  { label: "Maldives", value: "MDV" },
  { label: "Mali", value: "MLI" },
  { label: "Malta", value: "MLT" },
  { label: "Marshall Islands", value: "MHL" },
  { label: "Mauritania", value: "MRT" },
  { label: "Mauritius", value: "MUS" },
  { label: "Mexico", value: "MEX" },
  { label: "Micronesia", value: "FSM" },
  { label: "Moldova", value: "MDA" },
  { label: "Monaco", value: "MCO" },
  { label: "Mongolia", value: "MNG" },
  { label: "Montenegro", value: "MNE" },
  { label: "Morocco", value: "MAR" },
  { label: "Mozambique", value: "MOZ" },
  { label: "Myanmar", value: "MMR" },
  { label: "Namibia", value: "NAM" },
  { label: "Nauru", value: "NRU" },
  { label: "Nepal", value: "NPL" },
  { label: "Netherlands", value: "NLD" },
  { label: "New Zealand", value: "NZL" },
  { label: "Nicaragua", value: "NIC" },
  { label: "Niger", value: "NER" },
  { label: "Nigeria", value: "NGA" },
  { label: "North Macedonia", value: "MKD" },
  { label: "Norway", value: "NOR" },
  { label: "Oman", value: "OMN" },
  { label: "Pakistan", value: "PAK" },
  { label: "Palau", value: "PLW" },
  { label: "Panama", value: "PAN" },
  { label: "Papua New Guinea", value: "PNG" },
  { label: "Paraguay", value: "PRY" },
  { label: "Peru", value: "PER" },
  { label: "Philippines", value: "PHL" },
  { label: "Poland", value: "POL" },
  { label: "Portugal", value: "PRT" },
  { label: "Qatar", value: "QAT" },
  { label: "Romania", value: "ROU" },
  { label: "Russia", value: "RUS" },
  { label: "Rwanda", value: "RWA" },
  { label: "Saint Kitts and Nevis", value: "KNA" },
  { label: "Saint Lucia", value: "LCA" },
  { label: "Saint Vincent and the Grenadines", value: "VCT" },
  { label: "Samoa", value: "WSM" },
  { label: "San Marino", value: "SMR" },
  { label: "Sao Tome and Principe", value: "STP" },
  { label: "Saudi Arabia", value: "SAU" },
  { label: "Senegal", value: "SEN" },
  { label: "Serbia", value: "SRB" },
  { label: "Seychelles", value: "SYC" },
  { label: "Sierra Leone", value: "SLE" },
  { label: "Singapore", value: "SGP" },
  { label: "Slovakia", value: "SVK" },
  { label: "Slovenia", value: "SVN" },
  { label: "Solomon Islands", value: "SLB" },
  { label: "Somalia", value: "SOM" },
  { label: "South Africa", value: "ZAF" },
  { label: "South Sudan", value: "SSD" },
  { label: "Spain", value: "ESP" },
  { label: "Sri Lanka", value: "LKA" },
  { label: "Sudan", value: "SDN" },
  { label: "Suriname", value: "SUR" },
  { label: "Sweden", value: "SWE" },
  { label: "Switzerland", value: "CHE" },
  { label: "Syria", value: "SYR" },
  { label: "Taiwan", value: "TWN" },
  { label: "Tajikistan", value: "TJK" },
  { label: "Tanzania", value: "TZA" },
  { label: "Thailand", value: "THA" },
  { label: "Timor-Leste", value: "TLS" },
  { label: "Togo", value: "TGO" },
  { label: "Tonga", value: "TON" },
  { label: "Trinidad and Tobago", value: "TTO" },
  { label: "Tunisia", value: "TUN" },
  { label: "Turkey", value: "TUR" },
  { label: "Turkmenistan", value: "TKM" },
  { label: "Tuvalu", value: "TUV" },
  { label: "Uganda", value: "UGA" },
  { label: "Ukraine", value: "UKR" },
  { label: "United Arab Emirates", value: "ARE" },
  { label: "United Kingdom", value: "GBR" },
  { label: "United States", value: "USA" },
  { label: "Uruguay", value: "URY" },
  { label: "Uzbekistan", value: "UZB" },
  { label: "Vanuatu", value: "VUT" },
  { label: "Venezuela", value: "VEN" },
  { label: "Vietnam", value: "VNM" },
  { label: "Yemen", value: "YEM" },
  { label: "Zambia", value: "ZMB" },
  { label: "Zimbabwe", value: "ZWE" },
];

// Title: CheckoutAddressForm Component
// Description: React component for handling address input, validation, and autocomplete
function CheckoutAddressForm({ onAddressValidated }) {
  const { t } = useTranslation();
  const shop =
    new URLSearchParams(window.location.search).get("shop") ||
    "victorgroups.myshopify.com";
  const [address, setAddress] = useState({
    address1: "",
    city: "",
    province_code: "",
    country_code: "NGA",
    zip: "",
    landmark: "",
    isSuggested: false,
  });
  const [validationResult, setValidationResult] = useState(null);
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [showSuggestion, setShowSuggestion] = useState(false);

  // Title: Handle Input Changes
  const handleChange = (field) => (value) => {
    console.log(`Input changed: ${field} = ${value}`);
    setAddress((prev) => ({ ...prev, [field]: value, isSuggested: false }));
    setError("");
    setValidationResult(null);
    setShowSuggestion(false);
    if (field === "address1" && value.length > 3) {
      handleAutocomplete(value);
    } else {
      setSuggestions([]);
    }
  };

  // Title: Autocomplete Handler
  const handleAutocomplete = async (value) => {
    try {
      console.log(`Fetching autocomplete for query: ${value}`);
      const response = await getAutocompleteSuggestions(shop, value);
      const newSuggestions = response.suggestions || [];
      console.log("Autocomplete suggestions:", newSuggestions);
      setSuggestions(newSuggestions);
    } catch (err) {
      setError(t("addressForm.autocompleteError") || "Failed to fetch autocomplete suggestions");
      console.error("❌ Autocomplete error:", err.message);
      setSuggestions([]);
    }
  };

  // Title: Suggestion Selection Handler
  const handleSelectSuggestion = (suggestion) => {
    console.log("Selected suggestion:", suggestion);
    setAddress({
      address1: suggestion.address1 || "",
      city: suggestion.city || "",
      province_code: suggestion.province_code || "",
      country_code: suggestion.country_code || "NGA",
      zip: suggestion.zip || "",
      landmark: address.landmark,
      isSuggested: true,
    });
    setSuggestions([]);
    setShowSuggestion(false);
    setValidationResult(null);
  };

  // Title: Handle Suggested Address
  const handleUseSuggested = () => {
    if (!validationResult?.validationResult?.suggestedAddress) {
      console.log("No suggested address to apply");
      return;
    }

    console.log("✅ Using suggested address");
    const suggestedAddress = validationResult.validationResult.suggestedAddress;
    setAddress((prev) => ({
      ...prev,
      address1: suggestedAddress.address1,
      city: suggestedAddress.city,
      province_code: suggestedAddress.province_code,
      country_code: suggestedAddress.country_code,
      zip: suggestedAddress.zip,
      isSuggested: true,
    }));
    setShowSuggestion(false);

    // Update validationResult to reflect the suggested address as valid, preserving usage
    const updatedResult = {
      ...validationResult,
      data: {
        ...validationResult.data,
        line1: suggestedAddress.address1,
        city: suggestedAddress.city,
        provinceOrState: suggestedAddress.province_code,
        postalCode: suggestedAddress.zip,
        country: suggestedAddress.country_code,
        formattedAddress: `${suggestedAddress.address1}, ${suggestedAddress.city}, ${suggestedAddress.province_code}, ${suggestedAddress.country_code}, ${suggestedAddress.zip}`,
        status: "valid",
      },
      validationResult: {
        ...validationResult.validationResult,
        isValid: true,
        status: "valid",
        suggestedAddress: null, // Clear suggested address to prevent re-display
      },
      usage: validationResult.usage, // Preserve original usage
    };
    setValidationResult(updatedResult);
    onAddressValidated(updatedResult);

    // Cache the updated result for future re-verification
    const cacheKey = `validation_${shop}_${JSON.stringify({
      address1: suggestedAddress.address1,
      city: suggestedAddress.city,
      province_code: suggestedAddress.province_code,
      country_code: suggestedAddress.country_code,
      zip: suggestedAddress.zip,
    })}`;
    localStorage.setItem(cacheKey, JSON.stringify(updatedResult));
  };

  // Title: Keep Original Address
  const handleKeepOriginal = () => {
    setShowSuggestion(false);
    setValidationResult(null);
    console.log("✅ Keeping original address");
  };

  // Title: Form Submission Handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setValidationResult(null);
    setShowSuggestion(false);
    try {
      console.log("Submitting address for verification:", { ...address, shop });

      // Skip re-verification for suggested addresses with valid cache
      const cacheKey = `validation_${shop}_${JSON.stringify({
        address1: address.address1,
        city: address.city,
        province_code: address.province_code,
        country_code: address.country_code,
        zip: address.zip,
      })}`;
      if (address.isSuggested && localStorage.getItem(cacheKey)) {
        console.log("Using cached validation result for suggested address");
        try {
          const cachedResult = JSON.parse(localStorage.getItem(cacheKey));
          setValidationResult(cachedResult);
          onAddressValidated(cachedResult);
          return;
        } catch (err) {
          console.warn("Invalid cached validation result, proceeding with verification:", err.message);
          localStorage.removeItem(cacheKey);
        }
      }

      const result = await verifyAddress({ ...address, shop });
      console.log("Verification result:", JSON.stringify(result, null, 2));
      setValidationResult(result);

      // Cache the result for suggested addresses
      if (address.isSuggested) {
        localStorage.setItem(cacheKey, JSON.stringify(result));
      }

      if (result.validationResult?.suggestedAddress) {
        const areAddressesIdentical = (original, suggested) => {
          return (
            original.address1 === suggested.address1 &&
            original.city === suggested.city &&
            original.province_code === suggested.province_code &&
            original.country_code === suggested.country_code &&
            original.zip === suggested.zip
          );
        };

        const currentAddress = {
          address1: address.address1,
          city: address.city,
          province_code: address.province_code,
          country_code: address.country_code,
          zip: address.zip,
        };

        const isIdentical = areAddressesIdentical(
          currentAddress,
          result.validationResult.suggestedAddress
        );

        if (isIdentical) {
          console.log("✅ Address validated - no visual changes needed");
          setShowSuggestion(false);
        } else {
          console.log("📝 Address has meaningful suggestions");
          setShowSuggestion(true);
          handleUseSuggested(); // Auto-apply to avoid invalid submissions
        }
      } else {
        setShowSuggestion(false);
      }

      onAddressValidated(result);
    } catch (err) {
      const errorMessage = err.message.includes("429")
        ? t("addressForm.usageLimitReached") || "Usage limit reached"
        : t("addressForm.verifyError") || "Failed to verify address";
      setError(errorMessage);
      console.error("❌ Submit error:", err.message, err.response?.data);
    } finally {
      setLoading(false);
    }
  };

  // 🚨 NEW: Check if address is PO Box
  const isPOBoxAddress = () => {
    return validationResult?.validationResult?.status === "pobox";
  };

  // 🚨 NEW: Get PO Box Warning Message
  const getPOBoxWarning = () => {
    if (!isPOBoxAddress()) return null;
    
    return (
      <div className="mt-3 p-4 bg-yellow-50 border-l-4 border-yellow-400 rounded-r-lg">
        <div className="flex">
          <div className="flex-shrink-0">
            <svg className="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
          </div>
          <div className="ml-3">
            <p className="text-sm text-yellow-800 font-medium">
              ⚠️ PO Box Detected - Merchant Warning
            </p>
            <p className="text-sm text-yellow-700 mt-1">
              PO Box addresses are not suitable for physical deliveries. 
              This may cause shipping delays or failed deliveries. 
              Consider requesting a physical street address from the customer.
            </p>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="max-w-md mx-auto bg-gray-50 min-h-screen p-4">
      <div className="pt-8 pb-6">
        <h1 className="text-2xl font-bold text-gray-900 text-center mb-2">
          {t("addressForm.title") || "Add New Address"}
        </h1>
        <p className="text-gray-600 text-center text-sm">
          {t("Please enter your delivery address") || "Please enter your delivery address"}
        </p>
      </div>

      <div className="checkout-address-form-container">
        <form
          onSubmit={handleSubmit}
          className="space-y-6 bg-white p-6 rounded-xl shadow-sm border border-gray-100"
        >
          {/* Address Line 1 */}
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">
              {t("addressForm.address1") || "Street Address"} *
            </label>
            <input
              type="text"
              value={address.address1}
              onChange={(e) => handleChange("address1")(e.target.value)}
              className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 text-gray-900 placeholder-gray-400"
              placeholder={t("addressForm.address1Placeholder") || "Enter your street address"}
              required
            />
            {suggestions.length > 0 && (
              <ul className="mt-2 bg-white border border-gray-200 rounded-lg shadow-md max-h-48 overflow-y-auto">
                {suggestions.map((suggestion, index) => (
                  <li
                    key={index}
                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm text-gray-700"
                    onClick={() => handleSelectSuggestion(suggestion)}
                  >
                    {suggestion.formattedAddress ||
                      `${suggestion.address1}, ${suggestion.city}, ${suggestion.province_code}, ${suggestion.country_code}, ${suggestion.zip}`}
                  </li>
                ))}
              </ul>
            )}
          </div>

          {/* City */}
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">
              {t("addressForm.city")} *
            </label>
            <input
              type="text"
              value={address.city}
              onChange={(e) => handleChange("city")(e.target.value)}
              className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 text-gray-900 placeholder-gray-400"
              placeholder={t("addressForm.cityPlaceholder") || "Enter city"}
              required
            />
          </div>

          {/* State/Province */}
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">
              {t("addressForm.province")}
            </label>
            <input
              type="text"
              value={address.province_code}
              onChange={(e) => handleChange("province_code")(e.target.value)}
              className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 text-gray-900 placeholder-gray-400"
              placeholder={t("addressForm.provincePlaceholder") || "Enter state/province"}
            />
          </div>

          {/* Country */}
          <div className="space-y-2 relative">
            <label className="block text-sm font-medium text-gray-700">
              {t("addressForm.country")} *
            </label>
            <select
              value={address.country_code}
              onChange={(e) => handleChange("country_code")(e.target.value)}
              className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 text-gray-900 bg-white appearance-none cursor-pointer pr-10"
              required
            >
              <option value="">{t("selectCountry")}</option>
              {countryOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            <div className="absolute inset-y-0 right-0 top-6 flex items-center px-3 pointer-events-none">
              <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
              </svg>
            </div>
          </div>

          {/* ZIP/Postal Code */}
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">
              {t("addressForm.zip")} *
            </label>
            <input
              type="text"
              value={address.zip}
              onChange={(e) => handleChange("zip")(e.target.value)}
              className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 text-gray-900 placeholder-gray-400"
              placeholder={t("addressForm.zipPlaceholder") || "Enter ZIP/Postal Code"}
              required
            />
          </div>

          {/* Landmark */}
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">
              {t("addressForm.landmark")}
              <span className="text-gray-400 text-xs ml-1">(Optional)</span>
            </label>
            <input
              type="text"
              value={address.landmark}
              onChange={(e) => handleChange("landmark")(e.target.value)}
              className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 text-gray-900 placeholder-gray-400"
              placeholder={t("addressForm.landmarkPlaceholder") || "Nearby landmark (e.g., Next to City Mall)"}
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 disabled:from-gray-400 disabled:to-gray-500 text-white font-semibold py-4 px-6 rounded-lg transition-all duration-200 transform hover:scale-[1.02] disabled:scale-100 disabled:cursor-not-allowed shadow-lg hover:shadow-xl"
          >
            {loading ? (
              <div className="flex items-center justify-center space-x-2">
                <svg
                  className="animate-spin h-5 w-5 text-white"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  ></path>
                </svg>
                <span>{t("addressForm.validating") || "Validating Address..."}</span>
              </div>
            ) : (
              t("VerifyAddress") || "Validate & Continue"
            )}
          </button>

          {/* Error Display */}
          {error && (
            <div className="p-4 bg-red-50 border border-red-200 rounded-lg flex items-start space-x-3">
              <svg
                className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <p className="text-red-600 text-sm">{error}</p>
            </div>
          )}
        </form>

        {/* 🚨 FIXED: Validation Result Banner with PO Box Detection */}
        {validationResult && (
          <div className="mt-6 bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
            <div
              className={`p-4 rounded-lg flex items-start space-x-2 ${
                validationResult.validationResult?.isValid &&
                (validationResult.validationResult?.status === "valid" ||
                  validationResult.validationResult?.status === "corrected_hybrid")
                  ? "bg-green-50 border-green-200"
                  : isPOBoxAddress()
                  ? "bg-yellow-50 border-yellow-200"
                  : "bg-red-50 border-red-200"
              }`}
            >
              <svg
                className={`w-5 h-5 flex-shrink-0 mt-0.5 ${
                  validationResult.validationResult?.isValid &&
                  (validationResult.validationResult?.status === "valid" ||
                    validationResult.validationResult?.status === "corrected_hybrid")
                    ? "text-green-500"
                    : isPOBoxAddress()
                    ? "text-yellow-500"
                    : "text-red-500"
                }`}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                {isPOBoxAddress() ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-2.694-.833-3.464 0L3.034 16.5c-.77.833.192 2.5 1.732 2.5z"
                  />
                ) : validationResult.validationResult?.isValid ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 13l4 4L19 7"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                )}
              </svg>

              <div className="flex-1 space-y-3">
                <div className="space-y-2">
                  <p
                    className={`font-medium ${
                      isPOBoxAddress()
                        ? "text-yellow-800"
                        : validationResult.validationResult?.isValid &&
                          (validationResult.validationResult?.status === "valid" ||
                            validationResult.validationResult?.status === "corrected_hybrid")
                        ? "text-green-800"
                        : "text-red-800"
                    }`}
                  >
                    {isPOBoxAddress()
                      ? "PO Box Detected - Invalid Address"
                      : validationResult.validationResult?.isValid
                      ? t("Valid Address") || "Address is valid."
                      : t("Invalid Address") || "Address needs attention."}
                  </p>

                  {getPOBoxWarning()}

                  {validationResult.data?.formattedAddress && (
                    <div className="text-sm text-gray-700">
                      <p className="font-medium mb-1">
                        {isPOBoxAddress() 
                          ? "Detected PO Box Address:" 
                          : t("Suggested Address") || "Formatted Address:"
                        }
                      </p>
                      <p className="bg-white p-2 rounded border">
                        {validationResult.data.formattedAddress}
                      </p>
                    </div>
                  )}

                  {validationResult.validationResult?.coordinates && (
                    <p className="text-sm text-gray-600">
                      <span className="font-medium">{t("coordinates:") || "Coordinates:"}</span>{" "}
                      Latitude: {validationResult.validationResult.coordinates.latitude},{" "}
                      Longitude: {validationResult.validationResult.coordinates.longitude}
                    </p>
                  )}

                  <p className="text-sm text-gray-600">
                    <span className="font-medium">{t("provider:") || "Provider:"}</span>{" "}
                    {validationResult.validationResult?.provider || "FRX-FINDER"}
                  </p>

                  {validationResult.usage && (
                    <p className="text-sm text-gray-600">
                      <span className="font-medium">{t("usage:") || "Usage:"}</span>{" "}
                      {validationResult.usage.count} validations used
                      {validationResult.usage.remaining != null && (
                        <>, {validationResult.usage.remaining} remaining</>
                      )}
                      {validationResult.usage.isOverLimit && (
                        <span className="text-red-700">
                          {" "}
                          ({t("validationResult.limitExceeded") || "Limit exceeded"})
                        </span>
                      )}
                    </p>
                  )}
                </div>

                {validationResult.validationResult?.suggestedAddress &&
                  showSuggestion && (
                    <div className="flex space-x-3 pt-2">
                      <button
                        onClick={handleUseSuggested}
                        className="px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition-colors duration-200"
                      >
                        {t("addressForm.useSuggested") || "Use Suggested"}
                      </button>
                      <button
                        onClick={handleKeepOriginal}
                        className="px-4 py-2 bg-gray-200 text-gray-800 text-sm font-medium rounded-lg hover:bg-gray-300 transition-colors duration-200"
                      >
                        {t("addressForm.keepOriginal") || "Keep Original"}
                      </button>
                    </div>
                  )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default CheckoutAddressForm;